import React, { forwardRef } from "react";
import Select, { components } from "react-select";
import { Form } from "react-bootstrap";

import "./styles.css"; // Add floating styles here

export const FloatingSelectField = forwardRef((props, ref) => {
  const {
    label,
    placeholder = "Select...",
    options = [],
    selectedOption,
    setSelectedOption,
    valueText = "value",
    labelText = "label",
    error,
    focus,
    disabled,
    classNamePrefix = "select",
    boxClass = "",
    className = "",
    name,
  } = props;

  const invalid = !!(focus && error);

  const { ValueContainer, Placeholder } = components;

  // Custom floating placeholder rendering
  const CustomValueContainer = ({ children, ...props }) => (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, (child) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );

  const handleChange = (value) => {
    setSelectedOption(value);
  };

  const formattedOptions =
    valueText === "value" && labelText === "label"
      ? options
      : options.map((opt) => ({
        value: opt[valueText],
        label: opt[labelText],
      }));

  return (
    <div className={`floating-select-wrapper ${boxClass}`}>
      {/* Floating label */}
      <label
        className={`floating-label-custom ${selectedOption ? "has-value" : ""
          }`}
        htmlFor={name}
      >
        {label}
      </label>

      {/* React-Select Dropdown */}
      <Select
        ref={ref}
        inputId={name}
        name={name}
        isDisabled={disabled}
        className={`${className} ${invalid ? "is-invalid" : ""}`}
        classNamePrefix={classNamePrefix}
        options={formattedOptions}
        value={selectedOption}
        onChange={handleChange}
        placeholder={placeholder}
        components={{ ValueContainer: CustomValueContainer }}
        aria-invalid={invalid}
        aria-describedby={invalid ? `${name}-error` : undefined}
        styles={{
          container: (base) => ({
            ...base,
            border: invalid ? "1px solid #dc3545" : base.border,
            borderRadius: 4,
            position: "relative",
          }),
          control: (base) => ({
            ...base,
            boxShadow: "none",
            borderColor: invalid ? "#dc3545" : base.borderColor,
            "&:hover": {
              borderColor: invalid ? "#dc3545" : base.borderColor,
            },
            minHeight: "48px",
          }),
          valueContainer: (provided) => ({
            ...provided,
            paddingTop: "12px",
          }),
        }}
      />

      {/* Error feedback */}
      {invalid && (
        <Form.Control.Feedback
          id={`${name}-error`}
          type="invalid"
          className="d-block mt-1 invalid-feedback"
        >
          {error}
        </Form.Control.Feedback>
      )}
    </div>
  );
});
